import React, { useState } from 'react'
import { Col, Image, Modal, Row } from 'react-bootstrap'
import { brandImage5, classic10yearsImage, enlargeIcon, logoBlack } from '../../assets'

export default function Section5() {
    const [ShowImageEnlargeModal, setShowImageEnlargeModal] = useState(false)
    return (
        <Row className='section3 mx-0'>
            <Modal show={ShowImageEnlargeModal} onHide={() => setShowImageEnlargeModal(false)}>
                <Image src={classic10yearsImage} width='100%' />
            </Modal>
            <Col lg={6} className='d-flex flex-column justify-content-center align-items-center'>
                <Image src={logoBlack} width='382px' height='auto' />
                <p align='left' style={{ fontWeight: '700', marginTop: '32px' }}>
                    Made from 100% imported burma gurjan timber,
                    in which the core, middle panels, front and
                    back faces are 100% fully made out of Gurjan wood.</p>
                <Row className='mx-0 w-100' style={{ fontWeight: '500', marginTop: '20px', marginBottom: '41px' }}>
                    <p align='left' style={{ fontWeight: '700' }}>
                        Gurjan plywood is reputed for:</p>
                    <Col className='ps-0 col-auto'>
                        <ul>
                            <li style={{ textAlign: 'start' }}>High dimensional stability</li>
                            <li style={{ textAlign: 'start' }}>Structurally balanced</li>
                            <li style={{ textAlign: 'start' }}>Uniform strength</li>
                            <li style={{ textAlign: 'start' }}>Heavy and stiff</li>
                        </ul>
                    </Col>
                    <Col className='ps-0 ps-md-2 col-12 col-md-6'>
                        <ul>
                            <li style={{ textAlign: 'start' }}>High impact resistance</li>
                            <li style={{ textAlign: 'start' }}>All weather proof</li>
                            <li style={{ textAlign: 'start' }}>Great nail holding strength</li>
                            <li style={{ textAlign: 'start' }}>Borer proof</li>
                        </ul>
                    </Col>
                </Row>
            </Col>
            <Col lg={6} className='d-flex flex-column justify-content-center  align-items-center' style={{ minHeight: '645px' }}>
                <div style={{ cursor: 'pointer', zIndex: '2' }} onClick={() => setShowImageEnlargeModal(true)}>
                    <Image src={classic10yearsImage} width='256px' height='205px' style={{ boxShadow: '0px 25px 45px #000000' }} />
                    <div className='d-flex align-items-center w-100 justify-content-center mb-3 mt-3'>
                        <Image src={enlargeIcon} width='21px' height='21px' />
                        <p className='mb-0' style={{ color: 'white', fontWeight: '700' }}>CLICK TO ENLARGE</p>
                    </div>
                </div>
                <Image src={brandImage5} className='brand-image brand-image5' />
            </Col>
        </Row >
    )
}
